/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import { createBrowserRouter, Navigate } from 'react-router-dom'
import { ProtectedRoute } from '@/components/common/ProtectedRoute'
import { AppLayout } from '@/components/layout/AppLayout'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { UsersListPage } from '@/pages/admin/UsersListPage'
import { UserCreatePage } from '@/pages/admin/UserCreatePage'
import { UserEditPage } from '@/pages/admin/UserEditPage'
import UploadDocumentsPage from '@/pages/invoices/UploadDocumentsPage'
import IncomingInvoicesPage from '@/pages/invoices/IncomingInvoicesPage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: '/dashboard',
            element: <DashboardPage />,
          },
          // Admin routes
          {
            path: '/admin',
            element: <ProtectedRoute requireModule="admin" requireFunction="manage_users" />,
            children: [
              {
                path: 'users',
                element: <UsersListPage />,
              },
              {
                path: 'users/create',
                element: <UserCreatePage />,
              },
              {
                path: 'users/:id',
                element: <UserEditPage />,
              },
            ],
          },
          // Invoices routes
          {
            path: '/invoices',
            children: [
              {
                path: 'upload-documents',
                element: (
                  <ProtectedRoute requireModule="invoices" requireFunction="upload_documents" />
                ),
                children: [
                  {
                    index: true,
                    element: <UploadDocumentsPage />,
                  },
                ],
              },
              {
                path: 'incoming-invoices',
                element: (
                  <ProtectedRoute requireModule="invoices" requireFunction="incoming_invoices" />
                ),
                children: [
                  {
                    index: true,
                    element: <IncomingInvoicesPage />,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
])
